import React, { useState, useMemo, useCallback } from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import { Spin, List, Skeleton } from "antd";
import { Pagination } from "@/components/TableWithPagination";
import { NotesListPaginationType } from "../constants";
import NoteItem from "./NoteItem";

const NotesList = ({
  loading,
  notes: propNotes,
  totalItems,
  paginationType,
  getNotes,
  onNotesCountChange,
  page,
  onPageChange,
  pageSize,
  onPageSizeChange,
}) => {
  const [previousNotes, setPreviousNotes] = useState([]);

  const notes = useMemo(() => {
    if (paginationType === NotesListPaginationType.Simple) {
      return propNotes || [];
    }

    return previousNotes.concat(propNotes || []);
  }, [propNotes]);

  const renderItem = useCallback(
    item => {
      return (
        <NoteItem
          key={item.id}
          item={item}
          hideEditAndDeleteButtons={paginationType === NotesListPaginationType.Scroll}
          getNotes={getNotes}
          onNotesCountChange={onNotesCountChange}
        />
      );
    },
    [getNotes, onNotesCountChange],
  );

  const loadMoreNotes = useCallback(() => {
    if (
      totalItems <= page * pageSize ||
      typeof getNotes !== "function" ||
      loading ||
      paginationType !== NotesListPaginationType.Scroll
    ) {
      return;
    }

    setPreviousNotes(notes);
    getNotes(page + 1, pageSize);
  }, [page, pageSize, totalItems, loading, paginationType, getNotes]);

  return (
    <Spin
      spinning={loading}
      style={{
        height: paginationType === NotesListPaginationType.Scroll ? "300px" : "auto",
      }}
    >
      <InfiniteScroll
        dataLength={notes.length}
        hasMore={totalItems > page * pageSize}
        scrollableTarget="scrollableDiv"
        next={loadMoreNotes}
        loader={paginationType === NotesListPaginationType.Scroll ? <Skeleton paragraph={{ rows: 2 }} active /> : null}
        endMessage={null}
        onScroll={event => {
          event.stopPropagation();
        }}
      >
        <List
          itemLayout="horizontal"
          dataSource={notes}
          style={{
            width: "100%",
            minWidth: paginationType === NotesListPaginationType.Scroll ? "400px" : undefined,
          }}
          renderItem={renderItem}
        />
      </InfiniteScroll>

      {paginationType !== NotesListPaginationType.Scroll && (
        <Pagination
          page={page}
          pageSize={pageSize}
          totalItems={totalItems}
          showLessItems={true}
          showQuickJumper={false}
          showSizeChanger={paginationType === NotesListPaginationType.Normal}
          onPageChange={onPageChange}
          onPageSizeChange={onPageSizeChange}
        />
      )}
    </Spin>
  );
};

export default NotesList;
